import { DateTime } from 'luxon'
import { findUserTypeByCode, formatCpf, formatPhone } from '../../../helpers/helper'
import { displayMessage } from '../../../helpers/messages'

export const client_users_grid_columns = [
    {
        field: 'first_name',
        headerName: displayMessage('FIRST_NAME'),
        type: 'string',
        width: 200,
        valueFormatter: params => {
            const row = params.api.getRow(params.id)
            if (row.ClientUser?.first_name) return row.ClientUser?.first_name
            return displayMessage('EMPTY_01')
        },
    },
    {
        field: 'last_name',
        headerName: displayMessage('LAST_NAME'),
        type: 'string',
        width: 200,
        valueFormatter: params => {
            const row = params.api.getRow(params.id)
            if (row.ClientUser?.last_name) return row.ClientUser?.last_name
            return displayMessage('EMPTY_01')
        },
    },

    {
        field: 'email',
        headerName: displayMessage('EMAIL'),
        type: 'string',
        width: 250,
        valueFormatter: params => {
            const row = params.api.getRow(params.id)
            if (row.ClientUser?.email) return row.ClientUser?.email
            return displayMessage('EMPTY_01')
        },
    },
    {
        field: 'WorkSector',
        headerName: displayMessage('WORK_SECTOR'),
        type: 'string',
        width: 200,
        valueFormatter: params => {
            const row = params.api.getRow(params.id)
            if (row.ClientUser?.type === 1) return 'Todos'
            if (row.ClientUser?.ClientUserWorkSectors[0]?.WorkSector) return row.ClientUser?.ClientUserWorkSectors[0]?.WorkSector.name
            return displayMessage('EMPTY_01')
        },
        valueGetter: params => {
            const row = params.api.getRow(params.id)
            if (row.ClientUser?.type === 1) return 'Todos'
            if (row.ClientUser?.ClientUserWorkSectors[0]?.WorkSector) return row.ClientUser?.ClientUserWorkSectors[0]?.WorkSector.name
            return displayMessage('EMPTY_01')
        },
    },
    {
        field: 'type',
        headerName: displayMessage('USER_TYPE'),
        type: 'string',
        width: 200,
        valueFormatter: params => {
            const row = params.api.getRow(params.id)
            if (row.ClientUser?.type) {
                const userType = findUserTypeByCode(row.ClientUser?.type)
                return userType.description
            }
            return displayMessage('EMPTY_01')
        },
        valueGetter: params => {
            const row = params.api.getRow(params.id)
            if (row.ClientUser?.type) {
                const userType = findUserTypeByCode(row.ClientUser?.type)
                return userType.description
            }
            return displayMessage('EMPTY_01')
        },
    },
    {
        field: 'is_active',
        headerName: 'Status de ativação',
        width: 150,
        valueFormatter: params => {
            const row = params.api.getRow(params.id)
            return row.ClientUser?.is_active ? displayMessage('ACTIVE') : displayMessage('INACTIVE')
        },
        type: 'singleSelect',
        valueOptions: [
            { value: true, label: 'Ativo' },
            { value: false, label: 'Inativo' },
        ],
    },

    // {
    //     field: 'created_by_user_id',
    //     headerName: displayMessage('CREATED_BY'),
    //     type: 'string',
    //     width: 100,
    //     valueFormatter: params => {
    //         const row = params.api.getRow(params.id)
    //         if (row.ClientUser?.user_who_created) return `${row.ClientUser?.user_who_created.first_name} ${row.ClientUser?.user_who_created.last_name}`
    //         return displayMessage('EMPTY_01')
    //     },
    //     valueGetter: params => {
    //         const row = params.api.getRow(params.id)
    //         if (row.ClientUser?.user_who_created) return `${row.ClientUser?.user_who_created.first_name} ${row.ClientUser?.user_who_created.last_name}`
    //         return displayMessage('EMPTY_01')
    //     }
    // },
    {
        field: 'createdAt',
        headerName: displayMessage('CREATED_AT'),
        type: 'date',
        width: 200,
        valueFormatter: params => {
            const row = params.api.getRow(params.id)
            if (row.createdAt) return DateTime.fromISO(row.createdAt).toFormat('dd/MM/yyyy HH:mm:ss')
            return displayMessage('EMPTY_01')
        },
    },
]
